import script from "./NumberStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberStepper.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__